"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Admin5 = function Admin5(props) {
  var id = props.id,
    _props$width = props.width,
    width = _props$width === void 0 ? 19 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 24 : _props$height,
    _props$color = props.color,
    color = _props$color === void 0 ? '#6F6F6F' : _props$color,
    _props$title = props.title,
    title = _props$title === void 0 ? 'Admin5' : _props$title,
    _props$description = props.description,
    description = _props$description === void 0 ? 'Admin5' : _props$description;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 19 24"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title), /*#__PURE__*/_react["default"].createElement("desc", null, description), /*#__PURE__*/_react["default"].createElement("g", {
    id: "UI-Design_Final",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Britive-Admin_Tenant-",
    transform: "translate(-25.000000, -392.000000)",
    fill: color,
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "5",
    transform: "translate(25.000000, 392.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19,1.15141025 C19,0.515503931 18.4917959,0 17.8823974,0 L1.11760258,0 C0.500367718,0 0,0.501274109 0,1.1414241 L0,22.8585759 C0,23.488967 0.497170736,24 1.11270426,24 L12.2941176,24 L13.4117647,22.8571429 L1.11764706,22.8571429 L1.11764706,1.14285714 L17.8823529,1.14285714 L17.8823529,18.2857143 L19,17.1242011 L19,1.15141025 Z",
    id: "Shape"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Shape",
    points: "19 16.3347351 19 17.9509792 13.0844135 24 11.5038218 24"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19,17.1428571 L13.4014578,17.1428571 C12.7898907,17.1428571 12.2941176,17.6582574 12.2941176,18.2751749 L12.2941176,24 L13.4117647,22.8571429 L13.4117647,18.2857143 L17.8823529,18.2857143 L19,17.1428571 Z",
    id: "Shape"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.41840271,10.0763719 L7.70434376,12.1483129 C7.99889477,12.4171319 8.46577259,12.2973358 8.60130938,11.9181607 L10.462873,6.73430525 L12.2053663,8.90130523 C12.4603175,9.21891209 12.9499471,9.16578642 13.1340404,8.80054246 L15.871104,3.37016614 L14.8776438,2.84658977 L12.5277641,7.49916294 L10.7008769,5.2257843 C10.4264498,4.88391514 9.89256075,4.97675329 9.74407166,5.39216349 L7.83251592,10.7421735 L5.64244053,8.73469591 C5.37454142,8.49020055 4.953897,8.56381755 4.78076118,8.88549845 L2.63764774,12.8673357 L3.61679791,13.4183786 L5.41840271,10.0763719 Z",
    id: "Shape"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-path",
    x: "3.35294118",
    y: "16",
    width: "6.70588235",
    height: "1.14285714"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-path",
    x: "3.35294118",
    y: "19.4285714",
    width: "6.70588235",
    height: "1.14285714"
  })))));
};
Admin5.propTypes = _index.iconProps;
var _default = Admin5;
exports["default"] = _default;